import { Flex, Skeleton } from 'antd';
import { Text, Title } from 'components/mvp-typography';
import { User } from 'features/auth';
import { Role } from 'features/auth/types';
import {
  PatientInfoContext,
  useGetPatientInfo
} from 'features/patient/_utils/patient-info/hook-context-patientinfo';
import { useParams } from 'react-router-dom';
import { ClinicianRouterForPatientRoutes } from './patientid-router-clinician';
import { PatientRouter } from './patientid-router-patient';
import { ErrorDisplay } from 'components/ErrorDisplay';
import { BaseButton } from 'components/button/button-base';

/**
 * Patient routes where the `patientId` parameter is set.
 *
 * `patientId` can be any string.
 *
 * @param props
 * @returns
 */
export function PatientRouteSwitchPatientId(props: { user: User }) {
  const { patientId } = useParams<{ patientId: string }>();
  const { state: patientInfo, dispatch } = useGetPatientInfo(patientId);

  /**
   * Show nothing if the patient info is loading
   */
  if (patientInfo.isLoading) {
    return (
      <div>
        <p>Loading test-taker information</p>
        <Skeleton active />
      </div>
    );
  }

  /********
   * Error messages
   ********/
  if (patientInfo.hasError) {
    return (
      <Flex gap={16} vertical>
        <Title>Safely caught error</Title>
        <div>
          <Text>
            An error occured when fetching data for test-taker{' '}
            {`'${patientId}'`}. Please confirm the ID is correct and should
            exist.
          </Text>
          <Text>
            If you think this is an error please contact ConcussionRx and
            include a screenshot of this page
          </Text>
        </div>
        {patientInfo.error && (
          <ErrorDisplay
            error={patientInfo.error}
            title={`Caught error`}
            description={`URL: ${window.location.href}`}
          />
        )}
        <Flex>
          <div>
            <BaseButton type="link" href="/">
              Return home
            </BaseButton>
          </div>
        </Flex>
      </Flex>
    );
  }

  /**
   * Resolved router
   */
  const router =
    props.user.role === Role.Patient ? (
      <PatientRouter
        patientId={patientId}
        patientInfo={patientInfo}
        user={props.user}
      />
    ) : (
      <ClinicianRouterForPatientRoutes
        patientId={patientId}
        patientInfo={patientInfo}
      />
    );

  return (
    <PatientInfoContext.Provider
      value={{
        patientInfo,
        dispatch
      }}
    >
      {router}
    </PatientInfoContext.Provider>
  );
}
